import {
  RightLayoutContainer,
  PageTitleComp,
  TableLayoutData,
} from "../../styledElements";
import { React, useState, useEffect, useRef } from "react";
import { Button, PageHeader, Table, Tooltip } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import SearchContainer from "../../../Components/SearchBarHeader/searchBar";
import { useNavigate, useLocation } from "react-router-dom";
import { Styled } from "../../pageStyled";
import TableShimmer from "../../../Components/TableShimmer/tableShimmer";
import EmptyState from "../../../Components/EmptyState/emptyState";
import emptyState_Search from "../../../Assets/Images/emptyState_Search.svg";
import emptyState_NoData from "../../../Assets/Images/emptyState_NoData.svg";
import emptyState_ConnectionAPIError from "../../../Assets/Images/emptyState_ConnectionAPIError.svg";
import {
  getCuttersRecords,
  searchCutters,
  getFilteredCutters
} from "../../../Services/machineServices";
import moment from "moment";
import {
  currency_List,lengthUnit,weightUnit 
  } from "../../../Utils/Constant/MeasurementUnitList.jsx";


const CutterRecords = (props) => {
  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("user-details"))
  );
  const location = useLocation();
  const history = useNavigate();
  const [addToaster, setAddToaster] = useState(
    location.state?.action === "add"
  );
  const [cuttersRecords, setCuttersRecords] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [clearSearch, setClearSearch] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [filterTags, setFilterTags] = useState([]);
  const [loading, setLoading] = useState(true);
  const [emptyStateLabel, setEmptyStateLabel] = useState();
  const [emptyStatePropsData, setEmptyStatePropsData] = useState();
  const [rendering, setRendering] = useState(false);
  const [totalRecords, setTotalRecords] = useState();
  const capitalize = (item) => item.charAt(0).toUpperCase() + item.slice(1);

  const [tableParams, setTableParams] = useState({
    sort_by: "created_at",
    sort_type: "descending",
    page: 1,
    size: 10,
  });
  const paginationRef = useRef({
    sort_by: "created_at",
    sort_type: "descending",
    page: 1,
    size: 10
  });

  const titleRef = useRef(null);
  const [stickyOffsets, setStickyOffsets] = useState({ title: 58, table: 100 });

  useEffect(() => {
    const observer = new ResizeObserver(() => {
      const baseTop = 58;
      const titleHeight = titleRef.current?.offsetHeight || 0;

      setStickyOffsets({
        title: baseTop,
        table: baseTop + titleHeight
      });
    });

    if (titleRef.current) observer.observe(titleRef.current);

    return () => observer.disconnect();
  }, [rendering]);

  const columnsHead = useRef([
    {
      title: "Cutter Code",
      dataIndex: "code",
      width: "13%",
      sorter: {
        compare: (a, b) => a.code - b.code,
      },
      fixed: "left",
      align: "left",
    },
    {
      title: "Cutter Name",
      dataIndex: "name",
      width: "13%",
      fixed: "left",
    },
    {
      title: "GSM Range",
      dataIndex: "gsm_range",
      width: "11%",
    },
    {
      title: "Width Range",
      dataIndex: "width_range",
      width: "13%",
    },
    {
      title: "Left Edge Trim",
      dataIndex: "left_edge_trim",
      width: "10%",
    },
    {
      title: "Right Edge Trim",
      dataIndex: "right_edge_trim",
      width: "10%",
    },
    {
      title: "Effective Max Deckle",
      dataIndex: "effective_deckle_length",
      width: "12%",
    },
    {
      title: "Max Allowed Waste",
      dataIndex: "maximum_loss",
      width: "12%",
    },
    {
      title: "Type",
      dataIndex: "type",
      width: "10%",
    },
    {
      title: "Cutters",
      dataIndex: "cutters",
      width: "9%",
    },
    {
      title: "Reel Dia Range",
      dataIndex: "reel_dia_range",
      width: "13%",
    },
    {
      title: "Loading Stands",
      dataIndex: "loading_stands",
      width: "13%",
    },
    {
      title: "Capacity",
      dataIndex: "capacity",
      width: "13%",
    },
    {
      title: "Created Date",
      dataIndex: "created_at",
      width: "13%",
      sorter: () => { },
    },
    {
      title: "Status",
      dataIndex: "status",
      width: "10%",
      render: (text, record) => (
        <div className="statusVal" dataval={record.status}>
       <Styled>
             <Tooltip
              placement="bottomRight"
              title={
                record.status === "Active"
                  ? "This cutter can be used for deckle matching and production."
                  : record.status === "Disabled"
                  ? "This cutter is currently disabled and cannot be used for deckle match."
                  : null
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {" "}
              {record.status}
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
    {
      title: "Actions",
      dataIndex: "action",
      width: "11%",
      align: "center",
      render: (text, record) => (
        <div className="actionBtn">
          {userDetails.roles.machine_records.edit && (
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={"Edit this rewinder"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button onClick={() => handleEdit(record)}>
                  <Iconmoon icon="edit" size={16} color="#A19F9D" />
                </Button>
              </Tooltip>
            </Styled>
          )}
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"View details of this rewinder"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button onClick={() => handleView(record)}>
                <Iconmoon icon="file-view" size={16} color="#A19F9D" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
    },
  ]);
  
  const refresh  = () => {
    setLoading(true);
    setCuttersRecords();
    setSearchValue("");
    setClearSearch(true);
    setRendering(true);
  };

  const handleEdit = (record) => {
    history("../edit-cutter",{
      state: {
        action : 'edit',
        code : record.code,
        type : record.type

      }
    });
  };

  const handleView = (record) => {
    history("../view-cutter",{
      state: {
        action : 'view',
        code : record.code,
        type:record.type,
      }
    });
  };
  
  const routeChange = () => {
    history("../add-new-cutter",{
      state: {
        action : 'add',
      }
    });
  };
  const exportHandler = () => {
    const currentDate = new Date();
    const today = (currentDate.getDate() + "/" + currentDate.toLocaleString("default", { month: "long" }) + "/" +  currentDate.getFullYear());
    let fileName = "Cutter_Records_Kiaznn_"+today;
    if (appliedFilters.length) {
      history("../cutter-records/export-cutter", {
        state: {
          body: {
            appliedFilters: appliedFilters,
            page: "cutter records",
            type: "Filter",
            searchValue: searchValue

          },
          rootPage: "../cutter-records",
          fileName: fileName,
        },
      });
    } else if(!clearSearch && searchValue){
      let params = {
        sort_by: "created_at",
        sort_type: "descending",
      }
      history("../cutter-records/export-cutter", {
          state: {
            body: {
              searchValue: searchValue,
              params: params,
              page: "cutter records",
              type: "Search"
            },
            rootPage: "../cutter-records",
            fileName: fileName,
          },
      });
    } else {
      history("../cutter-records/export-cutter", {
        state: {
          body: {
            page: "cutter records",
            type: "All Data"
          },
          rootPage: "../cutter-records",
          fileName: fileName,
        },
      });
    }
  };

  function onChange(pagination, filters, sorter, extra) {
    setCuttersRecords([]);
    setLoading(true);
    columnsHead.current?.map((item) => {
      if(item.dataIndex !== sorter?.field){
        item["sortOrder"] = null;
      } 
      if (item.dataIndex == sorter?.field) {
        item["sortOrder"] = sorter ? sorter.order : "";
      }
    });
    const tempSort = sorter.order === "ascend" ? "ascending" : "descending";
    if (
      sorter.field &&
      (paginationRef.current.sort_type !== tempSort )
    ) {
      setClearSearch(true);
      setCurrentPage(1);
      setTableParams({
        page: 1,
        size: pagination.pageSize,
        sort_by: sorter.field,
        sort_type: tempSort,
      });
      paginationRef.current = {
        page: 1,
        size: pagination.pageSize,
        sort_by: sorter.field,
        sort_type: tempSort,
      };
    } else {
      setClearSearch(true);
      setCurrentPage(pagination.current);
      setTableParams({
        page: pagination.current,
        size: pagination.pageSize,
        sort_by: sorter.order ? sorter.field : "created_at",
        sort_type: tempSort,
      });
      paginationRef.current = {
        page: pagination.current,
        size: pagination.pageSize,
        sort_by: sorter.order ? sorter.field : "created_at",
        sort_type: tempSort,
      };
    }
  }

  const fetchCutterRecords = async (params) => {
    try {
      const records = await getCuttersRecords(params);
      if(!records?.cutters?.length){
        setEmptyStateLabel("noData");
      }
      const formattedRecords = records?.cutters?.map((cutter) => {
        return {
          code: cutter.code,
          name: cutter.name,
          gsm_range: `${cutter.minimum_gsm} - ${cutter.maximum_gsm}`,
          width_range: `${cutter.minimum_width} - ${cutter.maximum_width} ${lengthUnit[cutter.units.maximum_width].displayName.toUpperCase()}`,
          left_edge_trim: cutter.left_edge_trim + " " + lengthUnit[cutter.units.left_edge_trim].displayName.toUpperCase(),
          right_edge_trim: cutter.right_edge_trim + " " + lengthUnit[cutter.units.right_edge_trim].displayName.toUpperCase(),
          effective_deckle_length: cutter.effective_deckle_length + " " + lengthUnit[cutter.units.effective_deckle_length].displayName.toUpperCase(),
          maximum_loss: cutter.maximum_loss.toFixed(3) + " %",
          cutters: cutter.maximum_cutters,
          type: cutter.type.charAt(0).toUpperCase() + cutter.type.slice(1),
          reel_dia_range: `${cutter.minimum_reel_dia} - ${cutter.maximum_reel_dia} ${lengthUnit[cutter.units.maximum_reel_dia].displayName.toUpperCase()}`,
          loading_stands: cutter.loading_stands,
          capacity: cutter.capacity + " " + capitalize(weightUnit[cutter.units.capacity].displayName) + ' / day',
          created_at: moment(cutter.created_at).format("DD MMM YYYY"),
          status: cutter.status === "active" ? "Active" : "Disabled",
        };
      });
      setCuttersRecords(formattedRecords);
      setTotalRecords(records.total_cutters);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log("Error in fetching cutter records", err);
      setLoading(false);
      setEmptyStateLabel("connectionAPIError");
    }
  };

  const searchCutter = async (value = "") => {
    setCuttersRecords([]);
    setLoading(true);
    columnsHead.current?.map((item) => {
      item["sortOrder"] = null;
  });
    setSearchValue(value);
    // if (value === "" || value === null) {
    //   setAppliedFilters([]);
    //   setFilterTags([]);
    //   fetchCutterRecords(paginationRef.current);
    // }else {
    //   searchCutters(value, paginationRef.current)
    //     .then((response) => {
    //       setLoading(false);
    //       setEmptyStateLabel("search");
    //       const formattedRecords = response?.cutters?.map((cutter) => {
    //         return {
    //           code: cutter.code,
    //           name: cutter.name,
    //           gsm_range: `${cutter.minimum_gsm} - ${cutter.maximum_gsm}`,
    //           width_range: `${cutter.minimum_width} - ${cutter.maximum_width} ${lengthUnit[cutter.units.maximum_width].displayName.toUpperCase()}`,
    //           left_edge_trim: cutter.left_edge_trim + " " + lengthUnit[cutter.units.left_edge_trim].displayName.toUpperCase(),
    //           right_edge_trim: cutter.right_edge_trim + " " + lengthUnit[cutter.units.right_edge_trim].displayName.toUpperCase(),
    //           effective_deckle_length: cutter.effective_deckle_length + " " + lengthUnit[cutter.units.effective_deckle_length].displayName.toUpperCase(),
    //           maximum_loss: cutter.maximum_loss.toFixed(3) + " %",
    //           cutters: cutter.maximum_cutters,
    //           type: cutter.type.charAt(0).toUpperCase() + cutter.type.slice(1),
    //           reel_dia_range: `${cutter.minimum_reel_dia} - ${cutter.maximum_reel_dia} ${lengthUnit[cutter.units.maximum_reel_dia].displayName.toUpperCase()}`,
    //           loading_stands: cutter.loading_stands ,
    //           capacity: cutter.capacity + " " + capitalize(weightUnit[cutter.units.capacity].displayName) + ' / day',
    //           created_at: moment(cutter.created_at).format("DD MMM YYYY"),
    //           status: cutter.status === "active" ? "Active" : "Disabled",
    //         };
    //       });
    //       setCuttersRecords(formattedRecords);
    //       setTotalRecords(response.total_cutters);
    //     })
    //     .catch((error) => {
    //       console.log("Error in searching cutters:", error);
    //     });
    // }
  };

  const fetchFilteredCutters = () => {
    
    getFilteredCutters(paginationRef.current, appliedFilters,'',searchValue)
    .then((response) => {
      setLoading(false);
      setEmptyStateLabel("filter");
      const formattedRecords = response?.data?.cutters?.map((cutter) => {
        return {
          code: cutter.code,
          name: cutter.name,
          gsm_range: `${cutter.minimum_gsm} - ${cutter.maximum_gsm}`,
          width_range: `${cutter.minimum_width} - ${cutter.maximum_width} ${lengthUnit[cutter.units.maximum_width].displayName.toUpperCase()}`,
          left_edge_trim: cutter.left_edge_trim + " " + lengthUnit[cutter.units.left_edge_trim].displayName.toUpperCase(),
          right_edge_trim: cutter.right_edge_trim + " " + lengthUnit[cutter.units.right_edge_trim].displayName.toUpperCase(),
          effective_deckle_length: cutter.effective_deckle_length + " " + lengthUnit[cutter.units.effective_deckle_length].displayName.toUpperCase(),
          maximum_loss: cutter.maximum_loss.toFixed(3) + " %",
          cutters: cutter.maximum_cutters,
          reel_dia_range: `${cutter.minimum_reel_dia} - ${cutter.maximum_reel_dia} ${lengthUnit[cutter.units.maximum_reel_dia].displayName.toUpperCase()}`,
          loading_stands: cutter.loading_stands ,
          capacity: cutter.capacity + " " + capitalize(weightUnit[cutter.units.capacity].displayName) + ' / day',
          type: cutter.type.charAt(0).toUpperCase() + cutter.type.slice(1),
          created_at: moment(cutter.created_at).format("DD MMM YYYY"),
          status: cutter.status === "active" ? "Active" : "Disabled",
        };
      });
      setCuttersRecords(formattedRecords);
      setTotalRecords(response.data.total_cutters);
    })
    .catch((error) => 
    console.log(error),
    setEmptyStateLabel("connectionAPIError"));
  };

  const applyfilter = (filter) => {
    setCuttersRecords([]);
    columnsHead.current?.map((item) => {
      item["sortOrder"] = null;
  });
    setCurrentPage(1);
   
    paginationRef.current = {
      sort_by: "created_at",
      sort_type: "descending",
      page: 1,
      size: 10
    }
    let temp = appliedFilters;
    let alreadySetFilter = false;
    for (let i = 0; i < temp.length; i++) {
      if (temp[i].type === filter.type) {
        temp[i] = filter;
        alreadySetFilter = true;
      }
    }
    const tempVar = alreadySetFilter ? [...temp] : temp.concat(filter);
    setAppliedFilters(tempVar);
    setFilterTags(tempVar.map(formatFilters));
     setTableParams( (prevState) => ({
      sort_by: "created_at",
      sort_type: "descending",
      page: 1,
      size: 10
    }));
  };

  const formatFilters = (item) => {
  switch (item.type) {
    case "min_gsm":
      let minGsmOperand = "";
      let minGsmValue = "";
      if (item.operator === "in_range") {
        minGsmOperand = "between";
        minGsmValue = `${item.min_gsm_range} and ${item.max_gsm_range}`;
      } else if (item.operator === "equal_to") {
        minGsmOperand = "equals";
        minGsmValue = `${item.min_gsm}`;
      } else if (item.operator === "equal_to") {
        minGsmOperand = "equals";
        minGsmValue = `${item.min_gsm}`;
      } else if (item.operator === "less_than") {
        minGsmOperand = "less than";
        minGsmValue = `${item.min_gsm}`;
      } else {
        minGsmOperand = "greater than";
        minGsmValue = `${item.min_gsm}`;
      }
      return {
        type: item.type,
        formattedType: "Min.GSM",
        operand: minGsmOperand,
        value: minGsmValue,
      };
    case "max_gsm":
      let maxGsmOperand = "";
      let maxGsmValue = "";
      if (item.operator === "in_range") {
        maxGsmOperand = "between";
        maxGsmValue = `${item.max_gsm_start} and ${item.max_gsm_end}`;
      } else if (item.operator === "equal_to") {
        maxGsmOperand = "equals";
        maxGsmValue = `${item.max_gsm}`;
      } else if (item.operator === "less_than") {
        maxGsmOperand = "less than";
        maxGsmValue = `${item.max_gsm}`;
      } else {
        maxGsmOperand = "greater than";
        maxGsmValue = `${item.max_gsm}`;
      }
      return {
        type: item.type,
        formattedType: "Max.GSM",
        operand: maxGsmOperand,
        value: maxGsmValue,
      };
    case "min_deckle_width":
      let minDeckOperand = "";
      let minDeckValue = "";
      if (item.operator === "in_range") {
        minDeckOperand = "between";
        minDeckValue = `${item.min_deckle_width} and ${item.max_deckle_width}`;
      } else if (item.operator === "equal_to") {
        minDeckOperand = "equals";
        minDeckValue = `${item.deckle_width}`;
      } else if (item.operator === "less_than") {
        minDeckOperand = "less than";
        minDeckValue = `${item.deckle_width}`;
      } else {
        minDeckOperand = "greater than";
        minDeckValue = `${item.deckle_width}`;
      }
      return {
        type: item.type,
        formattedType: "Min. Deckle Width",
        operand: minDeckOperand,
        value: minDeckValue,
      };
    case "max_deckle_width":
      let maxDeckOperand = "";
      let maxDeckValue = "";
      if (item.operator === "in_range") {
        maxDeckOperand = "between";
        maxDeckValue = `${item.min_deckle_width} and ${item.max_deckle_width}`;
      } else if (item.operator === "equal_to") {
        maxDeckOperand = "equals";
        maxDeckValue = `${item.deckle_width}`;
      } else if (item.operator === "less_than") {
        maxDeckOperand = "less than";
        maxDeckValue = `${item.deckle_width}`;
      } else {
        maxDeckOperand = "greater than";
        maxDeckValue = `${item.deckle_width}`;
      }
      return {
        type: item.type,
        formattedType: "Max. Deckle Width",
        operand: maxDeckOperand,
        value: maxDeckValue,
      };
    case "maximum_loss":
        let maxWasteOperand = "";
        let maxWasteValue = "";
        if (item.operator === "in_range") {
          maxWasteOperand = "between";
          maxWasteValue = `${item.min_maximum_loss} and ${item.max_maximum_loss}`;
        } else if (item.operator === "equal_to") {
          maxWasteOperand = "equals";
          maxWasteValue = `${item.maximum_loss}`;
        } else if (item.operator === "less_than") {
          maxWasteOperand = "less than";
          maxWasteValue = `${item.maximum_loss}`;
        } else {
          maxWasteOperand = "greater than";
          maxWasteValue = `${item.maximum_loss}`;
        }
        return {
          type: item.type,
          formattedType: "Maximum Loss",
          operand: maxWasteOperand,
          value: maxWasteValue,
        };
    case "created_date":
        let dateOperand = "";
        let dateValue = "";
        if (item.start_date === item.end_date) {
          dateOperand = "-";
          dateValue = moment(item.start_date).format("DD MMMM YY");
        } else {
          dateOperand = "between";
          dateValue = `${moment(item.start_date).format(
            "DD MMMM YY"
          )} - ${moment(item.end_date).format("DD MMMM YY")}`;
        }
        return {
          type: item.type,
          formattedType: "Created date",
          operand: dateOperand,
          value: dateValue,
        };
    case "cutter_type":
      const typeValue =
        item.cutter_type === "both"
          ? `Simplex/Duplex`
          : item.cutter_type === "simplex"
          ? `Simplex`
          : `Duplex`;
      return {
        type: item.type,
        formattedType: "Cutter Type",
        operand: "-",
        value: typeValue,
      };
    case "status":
      const formattedStatus =
        item.status === "both"
          ? `Active/Disabled`
          : item.status === "active"
          ? `Active`
          : `Disabled`;
      return {
        type: item.type,
        formattedType: "Status",
        operand: "-",
        value: formattedStatus,
      };
      case "capacity":
        let capacityOperand = "";
        let capacityValue = "";
        if (item.operator === "in_range") {
          capacityOperand = "between";
          capacityValue = `${item.min_capacity} and ${item.max_capacity}`;
        } else if (item.operator === "equal_to") {
          capacityOperand = "equals";
          capacityValue = `${item.capacity}`;
        } else if (item.operator === "equal_to") {
          capacityOperand = "equals";
          capacityValue = `${item.capacity}`;
        } else if (item.operator === "less_than") {
          capacityOperand = "less than";
          capacityValue = `${item.capacity}`;
        } else {
          capacityOperand = "greater than";
          capacityValue = `${item.capacity}`;
        }
        return {
          type: item.type,
          formattedType: "Capacity",
          operand: capacityOperand,
          value: capacityValue,
        };
        case "minimum_reel_dia":
          let minReelOperand = "";
          let minReelValue = "";
          if (item.operator === "in_range") {
            minReelOperand = "between";
            minReelValue = `${item.minimum_reel_dia} and ${item.maximum_reel_dia}`;
          } else if (item.operator === "equal_to") {
            minReelOperand = "equals";
            minReelValue = `${item.minimum_reel_dia}`;
          } else if (item.operator === "less_than") {
            minReelOperand = "less than";
            minReelValue = `${item.minimum_reel_dia}`;
          } else {
            minReelOperand = "greater than";
            minReelValue = `${item.minimum_reel_dia}`;
          }
          return {
            type: item.type,
            formattedType: "Min. Reel Dia",
            operand: minReelOperand,
            value: minReelValue,
          };
        case "maximum_reel_dia":
          let maxReelOperand = "";
          let maxReelValue = "";
          if (item.operator === "in_range") {
            maxReelOperand = "between";
            maxDeckValue = `${item.minimum_reel_dia} and ${item.maximum_reel_dia}`;
          } else if (item.operator === "equal_to") {
            maxReelOperand = "equals";
            maxReelValue = `${item.maximum_reel_dia}`;
          } else if (item.operator === "less_than") {
            maxReelOperand = "less than";
            maxReelValue = `${item.maximum_reel_dia}`;
          } else {
            maxReelOperand = "greater than";
            maxReelValue = `${item.maximum_reel_dia}`;
          }
          return {
            type: item.type,
            formattedType: "Max. Reel Dia",
            operand: maxReelOperand,
            value: maxReelValue,
          };
        case "loading_stands":
            let loadingStandOperand = "";
            let loadingStandValue = "";
            if (item.operator === "in_range") {
              loadingStandOperand = "between";
              loadingStandValue = `${item.min_loading_stands} and ${item.max_loading_stands}`;
            } else if (item.operator === "equal_to") {
              loadingStandOperand = "equals";
              loadingStandValue = `${item.loading_stands}`;
            } else if (item.operator === "less_than") {
              loadingStandOperand = "less than";
              loadingStandValue = `${item.loading_stands}`;
            } else {
              loadingStandOperand = "greater than";
              loadingStandValue = `${item.loading_stands}`;
            }
            return {
              type: item.type,
              formattedType: "Loading Stands",
              operand: loadingStandOperand,
              value: loadingStandValue,
            };
        
  }
  };

  const removeFilter = (filter) => {
    setCuttersRecords([]);
    columnsHead.current?.map((item) => {
      item["sortOrder"] = null;
  });
      const filterList = appliedFilters.filter((item) => {
        return item.type !== filter.type;
      });
      const formattedFilterList = filterTags.filter((item) => {
        return item.type !== filter.type;
      });
      setFilterTags(formattedFilterList);
      setAppliedFilters(filterList);
      // setRendering(true);
      // setSearchValue("");
      //   setClearSearch(true);
        setLoading(true);
        setCurrentPage(1);
    setTableParams( (prevState) => ({
      sort_by: "created_at",
      sort_type: "descending",
      page: 1,
      size: 10
    }));
    paginationRef.current = {
      sort_by: "created_at",
      sort_type: "descending",
      page: 1,
      size: 10
    }
  };

  // useEffect(() => {
  //   setLoading(true);
  //   if(rendering && !appliedFilters.length && searchValue == "") {
  //     fetchCutterRecords(paginationRef.current);
  //     setRendering(false);
  //   } else if(!appliedFilters.length && searchValue == "") {
  //     fetchCutterRecords(paginationRef.current);
  //   }
  // }, [tableParams, rendering]);

  useEffect(() => {
    setLoading(true);
    if (appliedFilters.length) {
      fetchFilteredCutters();
    } else if (searchValue !== "") {
       searchCutters(searchValue, paginationRef.current)
        .then((response) => {
          setLoading(false);
          setEmptyStateLabel("search");
          const formattedRecords = response?.cutters?.map((cutter) => {
            return {
              code: cutter.code,
              name: cutter.name,
              gsm_range: `${cutter.minimum_gsm} - ${cutter.maximum_gsm}`,
              width_range: `${cutter.minimum_width} - ${cutter.maximum_width} ${lengthUnit[cutter.units.maximum_width].displayName.toUpperCase()}`,
              left_edge_trim: cutter.left_edge_trim + " " + lengthUnit[cutter.units.left_edge_trim].displayName.toUpperCase(),
              right_edge_trim: cutter.right_edge_trim + " " + lengthUnit[cutter.units.right_edge_trim].displayName.toUpperCase(),
              effective_deckle_length: cutter.effective_deckle_length + " " + lengthUnit[cutter.units.effective_deckle_length].displayName.toUpperCase(),
              maximum_loss: cutter.maximum_loss.toFixed(3) + " %",
              cutters: cutter.maximum_cutters,
              type: cutter.type.charAt(0).toUpperCase() + cutter.type.slice(1),
              reel_dia_range: `${cutter.minimum_reel_dia} - ${cutter.maximum_reel_dia} ${lengthUnit[cutter.units.maximum_reel_dia].displayName.toUpperCase()}`,
              loading_stands: cutter.loading_stands ,
              capacity: cutter.capacity + " " + capitalize(weightUnit[cutter.units.capacity].displayName) + ' / day',
              created_at: moment(cutter.created_at).format("DD MMM YYYY"),
              status: cutter.status === "active" ? "Active" : "Disabled",
            };
          });
          setCuttersRecords(formattedRecords);
          setTotalRecords(response.total_cutters);
        })
        .catch((error) => {
          console.log("Error in searching cutters:", error);
        });
    } else {
      fetchCutterRecords(paginationRef.current);
    }
  }, [appliedFilters, tableParams, searchValue,rendering]);

  useEffect(() => {
    let propsData = {};
    if(emptyStateLabel === "noData"){
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records in this list";
      propsData["subHeading"] = "There are no records to show in this list. Add your first record to view details here";
    } else if(emptyStateLabel === "search"){
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records found";
      propsData["subHeading"] = "There is no record matching your search keyword. Try adjusting your search to find what you are looking for.";
    } else if(emptyStateLabel === "filter"){
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records found";
      propsData["subHeading"] = "There is no record matching your filter. Try changing your filter to find what you are looking for.";
    } else {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "Something went wrong";
      propsData["subHeading"] = "Check your internet connection or try reloading the page.";
    }
    setEmptyStatePropsData(propsData);
  },[emptyStateLabel]);

  return (
    <RightLayoutContainer id="right-layout-container">
      <style dangerouslySetInnerHTML={{
        __html: `
        .ant-tabs, .ant-tabs-content-holder, .ant-tabs-content, .ant-tabs-tabpane {
          overflow: visible !important;
        }
        .ant-table-sticky-holder {
          z-index: 101 !important;
        }
        .tableDataFormat table colgroup col {
          min-width: 100px !important;
        }
      `}} />
      <PageTitleComp ref={titleRef} style={{ borderBottom: "0", position: "sticky", top: stickyOffsets.title, zIndex: 100, backgroundColor: "#fff", paddingBottom: "10px" }}>
        <PageHeader
          ghost={false}
          title="Cutter Records"
          extra={
            userDetails?.roles?.machine_records.edit && [
              <Button key="1" className="themeBtn" onClick={routeChange}>
                <Iconmoon icon="addcircle" size={14} color="#ffffff" />
                Add New Cutter
              </Button>,
            ]
          }
        ></PageHeader>
      </PageTitleComp>
      <TableLayoutData>
        <div className="tableDataFormat">
          <SearchContainer
            placeholder={"Search Cutter Code or Cutter Name"}
            fetchOrder={searchCutter}
            exportRole={cuttersRecords?.length ? true : false}
            exportTrigger={exportHandler}
            clearSearch={clearSearch}
            setClearSearch={setClearSearch}
            searchedValue={searchValue}
            filterOptions={[
              {
                key: 0,
                label: "Filter by Min GSM",
                value: "min_gsm",
                type: "inputSelect",
              },
              {
                key: 1,
                label: "Filter by Max GSM",
                value: "max_gsm",
                type: "inputSelect",
              },
              {
                key: 2,
                label: "Filter by Min Deckle Width",
                value: "min_deckle_width",
                type: "inputSelect",
                unitType : "length"
              },
              {
                key: 3,
                label: "Filter by Max Deckle Width",
                value: "max_deckle_width",
                type: "inputSelect",
                unitType : "length"
              },
              {
                key: 4,
                label: "Filter by Maximum Waste",
                value: "maximum_loss",
                type: "inputSelect",
              },
              {
                key: 5,
                label: "Filter by Capacity",
                value: "capacity",
                type: "inputSelect",
                unitType:"weight"
              },
              {
                key: 6,
                label: "Filter by Min Reel Dia",
                value: "minimum_reel_dia",
                type: "inputSelect",
                unitType:"length"
              },
              {
                key: 7,
                label: "Filter by Max Reel Dia",
                value: "maximum_reel_dia",
                type: "inputSelect",
                unitType:"length"
              },
              {
                key: 8,
                label: "Filter by Loading Stands",
                value: "loading_stands",
                type: "inputSelect",
              },
              {
                key: 9,
                label: "Filter by Created date",
                value: "created_date",
                type: "date",
              },
              {
                key: 10,
                label: "Filter by Type",
                value: "cutter_type",
                type: "multiSelect",
              },
              
              {
                key: 11,
                label: "Filter by Status",
                value: "status",
                type: "multiSelect",
              },
            ]}
            applyFilter={applyfilter}
          />
           {filterTags.map((filter) => (
            <span className="filter-tags">
              <Iconmoon icon="filter" size={13} color="#a8a8a8" />
              &nbsp;
              <span>{filter.formattedType}</span>
              &nbsp;
              <span>{filter.operand}</span>
              &nbsp;
              <span>{filter.value}</span>
              <span>
                {" "}
                <button
                  onClick={() => {
                    removeFilter(filter);
                  }}
                >
                  {" "}
                  <Iconmoon icon="wrong" size={15} color="#a8a8a8" />{" "}
                </button>
              </span>
            </span>
          ))}

            {loading ? (
                    <TableShimmer
                      header = {columnsHead.current}
                      scroll={{ x: window.screen.width < 1500 && 1460 }}
                    />
                  ):(
                    cuttersRecords?.length ? (
                      <Table
                        columns={columnsHead.current}
                        dataSource={cuttersRecords}
                        onChange={onChange}
                        pagination={{
                          pageSizeOptions: [10, 20, 50, 100],
                          showSizeChanger: true,
                          current: currentPage,
                          total: totalRecords,
                          showTitle: false,
                          pageSize: paginationRef.current.size,
                          showTotal: (total, range) =>
                            `Showing ${range[0]}-${range[1]} of ${total} results`,
                          }}
                          scroll={{ x: "max-content" }}
                          sticky={{
                            offsetHeader: stickyOffsets.table,
                            getContainer: () => {
                              let node = document.getElementById('right-layout-container');
                              while (node && node !== document.body) {
                                const style = window.getComputedStyle(node);
                                if (style.overflowY === 'auto' || style.overflowY === 'scroll') return node;
                                node = node.parentNode;
                              }
                              return window;
                            }
                          }}
                        />
                      ) : (
                        <EmptyState
                        img= {emptyStateLabel === "noData" || emptyStateLabel === "filter" ? emptyState_NoData : 
                        emptyStateLabel === "search" ? emptyState_Search : 
                        emptyState_ConnectionAPIError}
                        heading= {emptyStatePropsData?.heading}
                        subHeading= {emptyStatePropsData?.subHeading}
                        label={emptyStatePropsData?.label}
                        refresh={refresh}
                        />
                      )
                  )}
        </div>
      </TableLayoutData>
    </RightLayoutContainer>
  );
};

export default CutterRecords;
